module.exports = __webpack_public_path__ + "img/_DSC0544 2 2.db4990ca.png";